import { CardCarousel } from "./card-carousel.js";
const collectionsCarousels = document.querySelectorAll('.featured-collections__carousel');
collectionsCarousels?.forEach(el => new CardCarousel(el));

